import FlowControlSendEmail from './FlowControlSendEmail';
import FlowControlSendSlackMessage from './FlowControlSendSlackMessage';

const FlowControlSendOptions = ({ level, handleChange, values = {}, disabled = false }) => {
  return (
    <>
      <FlowControlSendEmail level={level} handleChange={handleChange} values={values} disabled={disabled} />
      <FlowControlSendSlackMessage level={level} handleChange={handleChange} values={values} disabled={disabled} />
    </>
  );
};

export default FlowControlSendOptions;
